import { LEGAL_INFO } from './legal-info';
import { LegalLayout } from './LegalLayout';

export function MentionsLegalesPage() {
  return (
    <LegalLayout
      title="Mentions légales"
      subtitle="Informations exigées par la loi pour la confiance dans l'économie numérique (LCEN, art. 6-III)."
    >
      <section>
        <h2>1. Éditeur du site</h2>
        <p>Le présent site et le service « {LEGAL_INFO.productName} » sont édités par :</p>
        <ul>
          <li>
            <strong>Raison sociale :</strong> {LEGAL_INFO.companyName}
          </li>
          <li>
            <strong>Marque commerciale :</strong> {LEGAL_INFO.brandName}, marque d’
            {LEGAL_INFO.companyName}
          </li>
          <li>
            <strong>Forme juridique :</strong> {LEGAL_INFO.legalForm}
          </li>
          <li>
            <strong>Capital social :</strong> {LEGAL_INFO.capital}
          </li>
          <li>
            <strong>Siège social :</strong> {LEGAL_INFO.legalAddress}
          </li>
          <li>
            <strong>SIRET :</strong> {LEGAL_INFO.siret}
          </li>
          <li>
            <strong>RCS :</strong> {LEGAL_INFO.rcs}
          </li>
          <li>
            <strong>N° TVA intracommunautaire :</strong> {LEGAL_INFO.vatNumber}
          </li>
          <li>
            <strong>Représentant légal / Directeur de la publication :</strong>{' '}
            {LEGAL_INFO.legalRepresentative}
          </li>
          <li>
            <strong>Contact :</strong>{' '}
            <a href={`mailto:${LEGAL_INFO.contactEmail}`}>{LEGAL_INFO.contactEmail}</a>
          </li>
          <li>
            <strong>Téléphone :</strong> {LEGAL_INFO.phone}
          </li>
          <li>
            <strong>Site de la marque :</strong>{' '}
            <a href={LEGAL_INFO.brandWebsiteUrl} target="_blank" rel="noopener noreferrer">
              {LEGAL_INFO.brandWebsiteUrl}
            </a>
          </li>
          <li>
            <strong>Site institutionnel :</strong>{' '}
            <a href={LEGAL_INFO.websiteUrl} target="_blank" rel="noopener noreferrer">
              {LEGAL_INFO.websiteUrl}
            </a>
          </li>
        </ul>
      </section>

      <section>
        <h2>2. Hébergement</h2>
        <p>Le service est hébergé par :</p>
        <ul>
          <li>
            <strong>Société :</strong> {LEGAL_INFO.hostingProvider}
          </li>
          <li>
            <strong>Adresse :</strong> {LEGAL_INFO.hostingAddress}
          </li>
          <li>
            <strong>Site :</strong>{' '}
            <a href={LEGAL_INFO.hostingWebsite} target="_blank" rel="noopener noreferrer">
              {LEGAL_INFO.hostingWebsite}
            </a>
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Propriété intellectuelle</h2>
        <p>
          L'ensemble des éléments composant le service « {LEGAL_INFO.productName} » (textes,
          graphismes, logo, code source, base de données, marques, modèles, etc.) est la propriété
          exclusive de {LEGAL_INFO.companyName} ou fait l'objet d'une autorisation d'usage
          régulière. La marque {LEGAL_INFO.brandName} et son logo appartiennent à{' '}
          {LEGAL_INFO.companyName}.
        </p>
        <p>
          Toute reproduction, représentation, modification, publication, transmission, totale ou
          partielle, des éléments du service, par quelque procédé que ce soit, sans autorisation
          écrite préalable de {LEGAL_INFO.companyName}, est interdite et constitue une contrefaçon
          sanctionnée par les articles L. 335-2 et suivants du Code de la propriété intellectuelle.
        </p>
        <p>
          Les marques et logos tiers cités (notamment « n8n ») demeurent la propriété de leurs
          détenteurs respectifs.
        </p>
      </section>

      <section>
        <h2>4. Responsabilité</h2>
        <p>
          {LEGAL_INFO.companyName} s'efforce d'assurer au mieux de ses possibilités l'exactitude et
          la mise à jour des informations diffusées sur ce service. Toutefois,{' '}
          {LEGAL_INFO.companyName} ne peut garantir l'exactitude, la précision ou l'exhaustivité des
          informations mises à disposition.
        </p>
        <p>
          L'utilisation du service se fait dans les conditions définies par les{' '}
          <a href="/legal/cgu">Conditions Générales d'Utilisation</a> et, pour les clients, par les{' '}
          <a href="/legal/cgv">Conditions Générales de Vente</a>.
        </p>
      </section>

      <section>
        <h2>5. Données personnelles</h2>
        <p>
          Le traitement des données à caractère personnel est décrit dans la{' '}
          <a href="/legal/confidentialite">Politique de confidentialité</a>. Pour toute question ou
          demande d'exercice de vos droits (accès, rectification, effacement, portabilité,
          opposition), contactez <a href={`mailto:${LEGAL_INFO.dpoEmail}`}>{LEGAL_INFO.dpoEmail}</a>
          .
        </p>
      </section>

      <section>
        <h2>6. Cookies</h2>
        <p>
          L'utilisation des cookies est décrite dans la{' '}
          <a href="/legal/cookies">Politique de cookies</a>. Le service n'utilise que des cookies
          strictement nécessaires à son fonctionnement (authentification).
        </p>
      </section>

      <section>
        <h2>7. Droit applicable</h2>
        <p>
          Les présentes mentions légales sont soumises au droit français. Tout litige relatif à leur
          interprétation et à leur exécution relève de la compétence des tribunaux français, sous
          réserve d'une attribution de compétence spécifique découlant d'un texte de loi ou
          réglementaire particulier.
        </p>
      </section>
    </LegalLayout>
  );
}
